import * as React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { View } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { TaxonomyTheme } from '../../../custom';

interface ThemeProps {
  entity: ImmutableEntity<TaxonomyTheme>;
}

const TaxonomyThemeFaqPage: React.FC<ThemeProps> = ({
  entity,
  ...props
}) => {
  const { t } = useTranslation();
  const taxonomy = entity.toJS();

  return (
    <div className={c('ThemeFaqPage')} {...props}>
      <Container>
        <h1 className="mb-16">
          <span className="asH2 text-capitalize">{t('pages.faq.title')}</span><br />
          {taxonomy.name[0].value}
        </h1>
        <View
          id="faq"
          display="by_theme"
          args={[taxonomy.tid[0].value]}
        />
      </Container>
    </div>
  );
};

export default TaxonomyThemeFaqPage;
